import React, {
    useState,
    useEffect,
    useContext,
    useRef,
    useCallback,
  } from "react";
  
 import AppContext from "../../context/Context";
 import {   Spinner  } from "react-bootstrap";

 
  const LoderCom = ({size}) => {

    const {
        config: { isDark },
      } = useContext(AppContext);
 

  
 
    return (
        <div className="loder-main">
              <Spinner className={size === "large"? "large-spinner": "small-spinner"} animation="border" variant="primary" />
        </div>
    );
  };
  
  export default LoderCom;
  